import { useState } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import AccountSidebar from "./components/AccountSidebar";
import BookingsTab from "./components/BookingsTab";
import PaymentsTab from "./components/PaymentsTab";
import AddressesTab from "./components/AddressesTab";
import ProfileTab from "./components/ProfileTab";
import { mockUser } from "../../mocks/accountData";

type Tab = "bookings" | "payments" | "addresses" | "profile";

export default function AccountPage() {
  const [activeTab, setActiveTab] = useState<Tab>("bookings");

  const tabContent: Record<Tab, JSX.Element> = {
    bookings: <BookingsTab />,
    payments: <PaymentsTab />,
    addresses: <AddressesTab />,
    profile: <ProfileTab />,
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#f9fafb" }}>
      <Navbar onBookNow={() => {}} />

      {/* Account header banner */}
      <div className="bg-cl-dark pt-28 pb-10 px-6 lg:px-10">
        <div className="max-w-screen-xl mx-auto flex items-center gap-5">
          <div className="w-16 h-16 rounded-full bg-cl-lime border-2 border-white flex items-center justify-center flex-shrink-0 cartoon-shadow">
            <span className="text-cl-dark font-black text-xl">{mockUser.avatarInitials}</span>
          </div>
          <div>
            <p className="text-white/60 text-sm font-semibold">Welcome back,</p>
            <h1 className="text-white font-black text-2xl md:text-3xl leading-tight">{mockUser.name}</h1>
          </div>
        </div>
      </div>

      {/* Main layout */}
      <main className="flex-1 max-w-screen-xl mx-auto px-6 lg:px-10 py-10 w-full">
        <div className="flex flex-col lg:flex-row gap-8 items-start">
          <AccountSidebar
            activeTab={activeTab}
            onTabChange={(tab) => setActiveTab(tab as Tab)}
          />
          <div className="flex-1 min-w-0">
            {tabContent[activeTab]}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
